import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { Store } from '@ngrx/store';

import { User } from '../../../models/user';
import { Attachment } from '../../../models/attachment';
import { Comment } from '../../../models/comment';

import { selectAllUsers } from '../../../features/user/user.selectors';
import {
  selectCurrentOrganizationId
} from '../../../features/organization/organization.selectors';
import { interval } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'comment-user',
    templateUrl: './comment-user.component.html',
    styleUrls: ['./comment-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CommentUserComponent {
  @Input({ required: true }) comment!: Comment;
  @Input({ required: true }) currentUser!: User;

  @Output() contentHeightChanged = new EventEmitter<void>();

  readonly users$ = this.store.select(selectAllUsers);
  readonly currentOrganizationId$ = this.store.select(selectCurrentOrganizationId);

  readonly refreshSince$ = interval(10000).pipe(
    startWith(0),
    map(() => Date.now())
  );

  constructor(private readonly store: Store) {}

  get attachments(): Attachment[] {
    return this.comment?.attachments ?? [];
  }

  dateToTimestamp(date: string): number {
    return new Date(date).getTime();
  }

  onCommentAttachmentHeightChanged(): void {
    this.contentHeightChanged.emit();
  }
}
